// ── Fraud & Device Risk proposed config (v2), sectionized by config file ────
//
// Mockup only (local state, never written to the workflow JSON). Device, IP
// and contact risk signals evaluate together as part of the same workflow
// execution — configured via:
//   fraud_config  — which signals are in scope, refer/fail thresholds
//   con_seon      — device intelligence provider connection
import { useState } from 'react'
import { Field, SectionLabel, TextInput, Toggle } from './fields'
import { ConfigSection } from './ConfigSection'

function FraudServiceSection() {
  const [deviceIntelligence, setDeviceIntelligence] = useState(true)
  const [ipRisk, setIpRisk] = useState(true)
  const [emailRisk, setEmailRisk] = useState(true)
  const [phoneRisk, setPhoneRisk] = useState(true)
  const [referThreshold, setReferThreshold] = useState('MEDIUM')
  const [failOnUnacceptable, setFailOnUnacceptable] = useState(true)
  return (
    <ConfigSection title="Fraud service config" file="fraud_config" defaultOpen>
      <SectionLabel>Signals in scope</SectionLabel>
      <Toggle label="Device intelligence (jailbreak, emulator, known-bad device)" checked={deviceIntelligence} onChange={setDeviceIntelligence} />
      <Toggle label="IP risk (VPN, proxy, known-bad network)" checked={ipRisk} onChange={setIpRisk} />
      <Toggle label="Email risk (disposable, newly-registered)" checked={emailRisk} onChange={setEmailRisk} />
      <Toggle label="Phone risk (VOIP, high-risk carrier)" checked={phoneRisk} onChange={setPhoneRisk} />

      <SectionLabel>Outcome</SectionLabel>
      <Field label="Refer threshold">
        <TextInput value={referThreshold} onChange={(e) => setReferThreshold(e.target.value)} placeholder="MEDIUM" />
      </Field>
      <Toggle label="Auto-fail on UNACCEPTABLE risk" checked={failOnUnacceptable} onChange={setFailOnUnacceptable} />
    </ConfigSection>
  )
}

function SeonConnectorSection() {
  const [endpoint, setEndpoint] = useState('https://api.seon.io/SeonRestService')
  const [apiKey, setApiKey] = useState('SECRET:.../seon/api_key')
  const [deviceFingerprintingOnly, setDeviceFingerprintingOnly] = useState(false)
  return (
    <ConfigSection title="Device intelligence connector" file="con_seon">
      <Field label="Endpoint"><TextInput value={endpoint} onChange={(e) => setEndpoint(e.target.value)} /></Field>
      <Field label="API key (secret path)"><TextInput value={apiKey} onChange={(e) => setApiKey(e.target.value)} placeholder="SECRET:…" /></Field>
      <Toggle label="Device fingerprinting only (skip email/phone lookups)" checked={deviceFingerprintingOnly} onChange={setDeviceFingerprintingOnly} />
    </ConfigSection>
  )
}

export function FraudProposedConfig() {
  return (
    <>
      <FraudServiceSection />
      <SeonConnectorSection />
    </>
  )
}
